var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.049,
    height: 21,
    viewBox: "0 0 21.049 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666a70;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Video",
    className: "cls-1",
    d: "M3267.9,142.249h-14.233a3.408,3.408,0,0,1-3.408-3.4v-14.2a3.408,3.408,0,0,1,3.408-3.4H3267.9a3.408,3.408,0,0,1,3.408,3.4v14.2A3.408,3.408,0,0,1,3267.9,142.249Zm-11.122-15.023a2.716,2.716,0,0,0-2.716,2.717v3.8a2.716,2.716,0,0,0,2.716,2.717h8.15a2.717,2.717,0,0,0,2.717-2.717v-3.8a2.717,2.717,0,0,0-2.717-2.717Zm2.717,1.63,4.841,2.958-4.841,2.958Z",
    transform: "translate(-3250.258 -121.249)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDownload);
export default __webpack_public_path__ + "static/media/videoDownload.f75b2466d9c13453e364e1b19d5a398d.svg";
export { ForwardRef as ReactComponent };